import React, { useEffect, useState } from "react";
import { Checkbox, makeStyles, IconButton } from "@material-ui/core";
import { Cancel } from "@material-ui/icons";
import RLDD from "react-list-drag-and-drop/lib/RLDD";

const useStyles = makeStyles((theme) => ({
  container: {
    overflowX: "auto",
  },
  previewWrapper: {
    position: "relative",
    "&  button": {
      position: "absolute",
      top: "0",
      right: "0",
    },
  },
  preview: {
    width: 100,
    height: 100,
    borderRadius: 4,
    margin: theme.spacing(0.5),
  },
  list: {
    display: "flex !important",
  },
}));

function ImageGrid({ images, setGridData, preImageRemove }) {
  const [localItems, setLocalItems] = useState(images);
  const handleRLDDChange = (newItems) => {
    setLocalItems(newItems);
  };

  const updateUpstream = () => {
    const isChangedItemOrder = localItems.some(
      (item, index) => item.id !== images[index].id
    );
    if (isChangedItemOrder) {
      setGridData(localItems);
    }
  };
  window.addEventListener("click", updateUpstream);

  useEffect(() => {
    return function () {
      window.removeEventListener("click", updateUpstream);
    };
  });

  const classes = useStyles();

  if (localItems?.length === 0) {
    return null;
  }
  const itemsWithId = localItems?.map((url, i) => ({ id: i, ...url }));
  return (
    <div className={classes.container}>
      <RLDD
        items={itemsWithId}
        cssClasses={classes.list}
        itemRenderer={(image, i) => {
          return (
            <div key={image.editedUri} className={classes.previewWrapper}>
              <IconButton onClick={() => preImageRemove(i)}>
                <Cancel color="secondary" />
              </IconButton>
              <img
                src={image.editedUri}
                className={classes.preview}
                alt="Preview"
              />
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Checkbox
                  checked={image.isChecked}
                  onChange={() => {
                    setGridData(
                      localItems.map((item, index) =>
                        index === i
                          ? { ...image, isChecked: !image.isChecked }
                          : item
                      )
                    );
                  }}
                />
              </div>
            </div>
          );
        }}
        onChange={handleRLDDChange}
      />
    </div>
  );
}
function areEqual(prevProps, nextProps) {
  return prevProps.images.count === nextProps.images.count;
}
export default React.memo(ImageGrid, areEqual);
